// removed by extract-text-webpack-plugin
module.exports = {"header":"_1AFq0gkryYxNahOg7RgQLE","frame":"_3PdisHGcm5c-iI7GMzKII3","logo":"_125qaSaNy6ZIi5kq9Iuwkg","text":"Dcjhfo0YEmKQ_SHQMhecj"};


//////////////////
// WEBPACK FOOTER
// ./src/css/components/header.css
// module id = 338
// module chunks = 0